import { type MessageProps } from '@post-office/placement-common/utils/message-renderer';

import { type renderer } from '../__generated__/client/render';

const excludedMessages = new Set(['test-message-inapp', 'message-template-template']);

export type Message = MessageProps<typeof renderer>;

export const getMessage = (
	initialMessages: { messageTemplateId: string; messageInstanceId: string }[],
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
): any => {
	const filteredMessages = ((initialMessages || []) as Message[]).filter(
		// eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
		(dataMessage) => !excludedMessages.has(dataMessage.messageTemplateId),
	);

	return filteredMessages[0];
};
